import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { LEAGUE, CLEAR_LEAGUE } from 'actions/leagues';

const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${LEAGUE}_LOADING`:
      return state.merge({ loading: true, error: null });
    case `${LEAGUE}_ERROR`:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    case `${LEAGUE}`:
      return state.merge(
        {
          loading: false,
          data: { [action.meta.id]: action.payload },
          error: null,
        },
        { deep: true },
      );
    case CLEAR_LEAGUE:
      return state.merge({
        loading: false,
        data: {},
        error: null,
      });
    default:
      return state;
  }
};
